import { sendDataLayerChatWidgetOpenedEvent } from '~/composables/useDataLayer';

const openZendeskChat = (source?: string) => {
    if (source) {
        window._lastChatSource = source;
        window._chatWidgetOpenedProgrammatically = true;
        sendDataLayerChatWidgetOpenedEvent(source);
    }
    window.$zopim.livechat.window.show();
};

export { openZendeskChat };
